<div class="main-container input" [ngClass]="{'disabled-input': readonly, 'invalid-input': invalidInput }">
  <div class="prefix d-flex justify-content-center align-items-center" *ngIf="prefix">
    <p class="mb-0 prefix-text">{{ prefix | currencySymbol  }}</p>
  </div>

  <input
    [readonly]="readonly"
    [placeholder]="placeHolder"
    (input)="onInputChange($event)"
    [(ngModel)]="value.inputValue"
    (blur)="onBlur()"
  />

  <select name="" id="" class="dropdown-input" (change)="onDropdownChange($event)" [(ngModel)]="value.dropdownValue" [disabled]="disableDrowdown || readonly">
    <option [value]="null" hidden>NA</option>
    <option *ngFor="let item of dropdownArray" [value]="item.value">{{ item.name }}</option>
  </select>
</div>
